import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import NoPhoto from '../../../assets/images/no-photo.svg';

import { selectWebsiteTheme } from '../../../store/slices/website';

import ListingParams from '../../../components-shared/ListingParams';
import ListingPrice from '../../../components-shared/ListingPrice';
import ListingNotAvailable from '../../../components-shared/ListingNotAvailable';

import {
  Container, Photo, Description, Title,
} from './styled';

const Item = ({ item, websiteId }) => {
  const navigate = useNavigate();
  const { colors } = useSelector(selectWebsiteTheme);

  const handleClick = () => {
    navigate(`/${item.listing_id}/details?website_id=${websiteId}`);
  };

  return (
    <Container onClick={handleClick}>
      {!item.is_available && <ListingNotAvailable />}

      <Photo
        bgColor={colors[2].color}
        placeholder={item.images[0]?.medium_url ? 0 : 1}
        image={item.images[0]?.medium_url || NoPhoto}
      />
      <Description>
        <Title>{item.listing_property.display_name}</Title>
        <ListingPrice listing={item} />
        <ListingParams listing={item} />
      </Description>
    </Container>
  );
};

Item.propTypes = {
  item: PropTypes.object.isRequired,
  websiteId: PropTypes.string.isRequired,
};

export default Item;
